
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';

// Internal
import { Loading, ReintegriList, ReintegriCards, LoadingTemplateType } from '@/components';
import { Utente, FinderReintegri, Reintegro } from '@/models';
import { store, StoreActions, StoreMutations, FiltriReintegri } from '@/store';

@Component({
  components: {
    Loading,
    ReintegriList,
    ReintegriCards
  }
})
export default class Reintegri extends Vue {

  get loading() { return store.state.loading; }

  get user() { return store.state.currentUsr; }

  get userIsAdmin() {
    return (
      this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
      undefined
    );
  }

  private templates = LoadingTemplateType;

  get pageSize(): number { return store.state.ui.dimensionePaginaListe; }

  get page(): number { return store.state.uiReintegri.pagina; }
  set page(value: number) { this.caricaPaginaReintegri(value); } //store.commit(StoreMutations.SetPaginaListaOrdini, value); }

  get pageCount(): number { return store.state.uiReintegri.totPagine; }
  get numTotReintegri(): number { return store.state.uiReintegri.totReintegri; }

  get vistaLista(): boolean { return store.state.uiReintegri.listView; }

  get reintegri(): Reintegro[] {
    return store.state.listaReintegri;
  }

  get fornitori(): Utente[] {
    return store.state.fornitori;
  }

  get fornitore(): Utente | undefined {
    return store.state.fornitore;
  }

  get loadTemplateCorrente() : LoadingTemplateType {
    return store.state.uiReintegri.listView ? LoadingTemplateType.TwoLineAvatarList : LoadingTemplateType.Card;
  }

  set fornitore(fornitore: Utente | undefined) {
    store.commit(StoreMutations.SetFornitore, fornitore);
    if (fornitore) {
      this.idFornitore = fornitore.id;
      this.caricaPaginaReintegri(1);
    } else {
      this.idFornitore = '';
      store.commit(StoreMutations.SetReintegri, []);
    }
    //store.dispatch(StoreActions.GetDatiLookupFornitore, this.idFornitore);
  }

  private idFornitore: string = '';

  created(): void {    
    if (this.userIsAdmin) {
      this.fornitore = undefined;      
    } else {
      this.idFornitore = this.user.idFornitore;
    }
    this.caricaPaginaReintegri(1);
  }

  private caricaPaginaReintegri(pagina: number): void {

    let parametri: FinderReintegri = new FinderReintegri(this.idFornitore, pagina);
    parametri.ApplicaFiltriReintegri(store.state.uiReintegri.filtri);

    store.dispatch(StoreActions.GetReintegri, parametri);
  }

  @Watch("$store.state.uiReintegri.filtri")
  onCambioFiltri(filtriNew: FiltriReintegri) {
    this.caricaPaginaReintegri(store.state.uiOrdini.pagina);
  }

  private mounted() {    
    //store.dispatch(StoreActions.WatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }

  private destroyed() {
    //store.dispatch(StoreActions.UnwatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }
}
